export default {
  SPIN: 'ÎNVÂRTE',
  'You are not eligible for free spins':
    'Doar conturile Steam cu jocul CSGO și fără VAC sunt eligibile pentru monede gratuite. Reconectați-vă pe site pentru a actualiza.',
  'It must be 24 hours since last roll': 'Au trecut 24 de ore de la ultima rotire.',
};
